import { render } from "./SwipeCarousel.vue?vue&type=template&id=53cd017f&scoped=true"
import script from "./SwipeCarousel.vue?vue&type=script&lang=js"
export * from "./SwipeCarousel.vue?vue&type=script&lang=js"

import "./SwipeCarousel.vue?vue&type=style&index=0&id=53cd017f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cd017f"]])

export default __exports__